import { Animated } from 'react-native';
export function hasDiff(value, secondValue) {
    if (typeof value !== typeof secondValue) {
        return true;
    }
    if (value instanceof Animated.Value && !(secondValue instanceof Animated.Value)) {
        return true;
    }
    if (secondValue instanceof Animated.Value && !(value instanceof Animated.Value)) {
        return true;
    }
    if (secondValue instanceof Animated.Value && value instanceof Animated.Value) {
        return false;
    }
    const textTypes = ['string', 'number'];
    if (!value || !secondValue || textTypes.includes(typeof value)) {
        if (value === secondValue) {
            return false;
        }
        return true;
    }
    if (Array.isArray(value)) {
        const firstCheck = value.find((x, i) => hasDiff(x, secondValue[i]));
        if (firstCheck) {
            return true;
        }
        const secondCheck = secondValue.find((x, i) => hasDiff(x, value[i]));
        if (secondCheck) {
            return true;
        }
        return false;
    }
    const firstCheck = Object.entries(value).find(([key, value]) => hasDiff(value, secondValue[key]));
    if (firstCheck) {
        return true;
    }
    const secondCheck = Object.entries(secondValue).find(([key, v]) => {
        if (value[key]) {
            return false;
        }
        return hasDiff(v, value[key]);
    });
    if (secondCheck) {
        return true;
    }
    return false;
}
